export default "__VITE_ASSET__f4a41557__"